import React from 'react';
import Reflux from 'reflux';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import { Row, Col } from 'bootstrap';
import { OrderedMap } from 'immutable';

import CueOverUnder from 'main/components/show/cuesheet/cueOverUnder.jsx';
import CueClock from 'main/components/show/cuesheet/cueClock.jsx';
import EventClock from 'shared/components/event/clock.jsx';
import EventAvatar from 'shared/components/event/avatar.jsx';
import ShowsMenu from 'shared/components/menus/shows.jsx';
import ShareMenu, { menuId } from 'main/components/show/cuesheet/shareMenu.jsx';
import ViewMenu from 'main/components/show/cuesheet/viewMenu.jsx';
import Toolbar from 'main/components/show/cuesheet/toolbar.jsx';
import TooltipConstants from 'shared/constants/TooltipConstants.jsx';
import UIRegions from 'shared/constants/UIRegions';
import ModalActions from 'shared/flux/actions/ModalActions';

import UserSessionStore from 'flux/stores/UserSessionStore';
import PopoverStore from 'shared/flux/stores/PopoverStore';
import SearchActions from 'flux/actions/SearchActions';
import CuesheetCueClockActions from 'flux/actions/cuesheet/CuesheetCueClockActions';
import TeamViewStore from 'flux/stores/TeamViewStore';
import EventViewStore from 'flux/stores/EventViewStore';
import CuesheetStore from 'flux/stores/cuesheet/CuesheetStore';
import CuesheetCueClockStore from 'flux/stores/cuesheet/CuesheetCueClockStore';
import EventShowListStore from 'flux/stores/EventShowListStore';
import AlertBarStore from 'flux/stores/AlertBarStore';
import classNames from 'classnames';

import RouteActions from 'flux/actions/RouteActions';
import ActivityAuditListActions from 'flux/actions/ActivityAuditListActions';
import RoleHelper from 'shared/lib/role';
import { hasGlobalElementsFullAccess } from 'shared/lib/permission';
import { WithTooltip } from '@shoflo-rundown/polymer.legacy';
import PermissionStore from 'flux/stores/PermissionStore';
import EventFolderListActions from 'flux/actions/EventFolderListActions';
import EventFolderListStore from 'flux/stores/EventFolderListStore';

/**
 * Cuesheet Header
 */
export default React.createClass({
  displayName: 'CuesheetHeader',

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  mixins: [
    Reflux.ListenerMixin,
    PureRenderMixin,
    Reflux.connect(TeamViewStore, 'team'),
    Reflux.connect(EventViewStore, 'event'),
    Reflux.connect(UserSessionStore, 'user'),
    Reflux.connect(PermissionStore, 'permissions'),
    Reflux.connectFilter(
      CuesheetCueClockStore,
      'toggleFullScreenClock',
      (state) => state.get('toggleFullScreenClock'),
    ),
    Reflux.connectFilter(CuesheetStore, 'show', (st) => st.get('show')),
    Reflux.connectFilter(CuesheetStore, 'loadFailureCode', (state) =>
      state.get('loadFailureCode'),
    ),
    Reflux.connectFilter(EventShowListStore, 'shows', (st) => st.get('shows')),
    Reflux.connect(PopoverStore, 'popover'),
    Reflux.connect(AlertBarStore, 'alert'),
    Reflux.connect(EventFolderListStore, 'folderListStore'),
  ],

  propTypes: {
    lightTheme: React.PropTypes.bool,
    disableLightTheme: React.PropTypes.bool,
    grid: React.PropTypes.bool,
    displaySearch: React.PropTypes.bool,
    displayItemRunTime: React.PropTypes.bool,
    displayThemeSwitch: React.PropTypes.bool,
  },

  getDefaultProps() {
    return {
      lightTheme: false,
      disableLightTheme: false,
      grid: false,
      displayItemRunTime: true,
      displayThemeSwitch: true,
      displaySearch: true,
    };
  },

  render() {
    const { user, toggleFullScreenClock, show, team, event } = this.state;

    if (!show || team.size === 0 || event.size === 0) return null;

    const { disableLightTheme, lightTheme, displayItemRunTime } = this.props;

    let fullPageCueClock = (
      <CueClock fullscreen={toggleFullScreenClock} hideDescription />
    );

    if (!displayItemRunTime || !toggleFullScreenClock) fullPageCueClock = null;

    let lightThemeClasses = {
      'cs-header-light': user.get('cuesheetTheme') === 'light' || lightTheme,
    };
    if (disableLightTheme) lightThemeClasses = {};

    const gridClasses = classNames(
      'container-fluid',
      'cs-header',
      lightThemeClasses,
    );

    return (
      <div className="disable-text-highlight">
        {fullPageCueClock}
        <header className={gridClasses} id="cs-header">
          <Row className="flexed-rows">
            {this._getNavIcon()}
            {this._getEventTitleAndShowMenu()}
            {this._getHeaderToolbar()}
            {this._getHeaderClocks()}
            {this._getHeaderMiscOptions()}
          </Row>
        </header>
      </div>
    );
  },

  _backButtonHandler() {
    const { team, event } = this.state;
    let backActionHandler =
      event && event.get('globalTemplateContainer')
        ? RouteActions.goToTeamTemplates
        : RouteActions.goToEvent;
    backActionHandler({ teamId: team.get('_id'), eventId: event.get('_id') });
  },

  _getNavIcon() {
    const { grid } = this.props;

    const cols = {
      xs: 4,
      sm: 3,
      md: 2,
      lg: 2,
    };

    if (grid) {
      cols.md = 2;
    }

    const contentNode = (
      <div className="cs-header-back-button" onClick={this._backButtonHandler}>
        <span className="fa fa-3x fa-arrow-left" />
        Back
      </div>
    );

    return <Col {...cols}>{contentNode}</Col>;
  },

  _getEventTitleAndShowMenu() {
    const { event, team } = this.state;
    const { grid } = this.props;
    const hasPhoto = event.has('photo');
    const hasOverUnder = this._shouldHaveOverUnder();

    //show with no photo or over/under
    let cols = { xs: 10, sm: 7, md: 7, lg: 7 };
    if (!grid) {
      if (hasPhoto) cols.lg = 8;
      if (hasOverUnder) cols = { xs: 10, sm: 6, md: 5, lg: 7 };
      if (hasPhoto && hasOverUnder) cols = { xs: 10, sm: 6, md: 5, lg: 7 };
    }
    if (grid) {
      cols = { xs: 16, sm: 7, md: 8, lg: 10 };
    }

    const eventAvatarNode = event.get('photo') ? (
      <EventAvatar uri={event.get('photo')} />
    ) : null;

    return (
      <Col {...cols}>
        <div className="cs-header-info-wrapper">
          {eventAvatarNode}
          <div className="cs-header-title-wrapper">
            <div
              className="cs-header-event-title"
              onClick={() =>
                RouteActions.goToEvent({
                  teamId: team.get('_id'),
                  eventId: event.get('_id'),
                })
              }
            >
              {event.get('title')}
            </div>
            <div
              className={classNames('cs-header-show-menu-wrapper', {
                'cs-header-grid-show-menu': grid,
              })}
            >
              {this._getShowMenuNode()}
            </div>
          </div>
        </div>
      </Col>
    );
  },

  _getHeaderToolbar() {
    const { alert, event } = this.state;
    const { grid } = this.props;
    const hasOverUnder = this._shouldHaveOverUnder();
    const hasPhoto = event.has('photo');

    const showToolbar = !alert.get('size');

    let cols = { sm: 5, md: 4, lg: 6 };
    if (!grid) {
      if (hasPhoto) cols.lg = 5;
      if (hasOverUnder) cols.lg = 4;
      if (hasPhoto && hasOverUnder) cols.lg = 4;
    }

    if (grid) {
      cols = { xs: 16, sm: 9, md: 7, lg: 6 };
    }

    return (
      <Col className="hidden-xs" {...cols}>
        <div className="cs-header-toolbar">{showToolbar && <Toolbar />}</div>
      </Col>
    );
  },

  _getHeaderClocks() {
    const { show } = this.state;
    const displayClocks = show.get('displayClocks');
    const { displayItemRunTime, grid } = this.props;
    if (grid) return;

    const shouldHaveOverUnder = this._shouldHaveOverUnder();
    let clocksCols = { xs: 10, sm: 9, md: 6, lg: 5 };
    if (shouldHaveOverUnder) {
      clocksCols = { xs: 10, sm: 9, md: 8, lg: 7 };
    }

    let clocksNode = null;
    let cueOverUnderNode = null;
    let cueClockNode = <CueClock />;

    if (!displayItemRunTime) cueClockNode = null;

    if (shouldHaveOverUnder) {
      cueOverUnderNode = <CueOverUnder />;
    }

    if (displayClocks) {
      clocksNode = (
        <div className="cs-clocks-wrapper">
          {cueOverUnderNode}
          {cueClockNode}
          <EventClock />
        </div>
      );
    }

    return <Col {...clocksCols}>{clocksNode}</Col>;
  },

  _getHeaderMiscOptions() {
    const { show, loadFailureCode, team, event, user, popover } = this.state;

    if (loadFailureCode) return null;

    const { displayThemeSwitch, grid } = this.props;

    let toolsColumns = { sm: 3, md: 5, lg: 4 };

    const showId = show.get('_id');
    const eventId = event.get('_id');
    const teamId = team.get('_id');

    const shareMenuProps = {
      params: {
        showId,
        eventId,
        teamId,
      },
      displayType: show.get('displayType'),
      user,
      team,
      showMenu: popover.get(menuId),
    };

    const searchIconNode = (
      <WithTooltip placement="bottom" tip={TooltipConstants.CSSearch}>
        <div className="cs-info">
          <a
            onClick={this._handleToggleSearchVisibility}
            className="fa fa-2x fa-search"
          />
        </div>
      </WithTooltip>
    );

    let viewSwitcherNode = (
      <ViewMenu
        {...{ displayThemeSwitch, teamId, eventId, showId, user, team, event }}
      />
    );

    if (grid) {
      viewSwitcherNode = null;
      toolsColumns = { md: 7, lg: 6 };
    }

    return (
      <Col {...toolsColumns} className="hidden-xs hidden-sm">
        <div className="cs-header-icon-button-wrapper">
          <div className="cs-header-icon-buttons">
            {this._getGlobalElements()}
            {viewSwitcherNode}
            {searchIconNode}
            {this._getKeyboardShortcuts()}
            <ShareMenu {...shareMenuProps} />
            <WithTooltip
              placement="bottom"
              tip={TooltipConstants.CSActivityFeed}
            >
              <div className="cs-activity-feed">
                <a
                  onClick={() => ActivityAuditListActions.toggleVisibility()}
                  className="fa fa-2x fa-bolt"
                />
              </div>
            </WithTooltip>
          </div>
        </div>
      </Col>
    );
  },

  _getGlobalElements() {
    const { user, team } = this.state;
    const teamId = team.get('_id');

    const isTeamAdmin = RoleHelper.hasTeamAdminRole(user, teamId);

    if (!isTeamAdmin) return null;

    const hasGlobalElementsPermission = hasGlobalElementsFullAccess(
      team.get('permissions'),
    );

    const globalElementAction = hasGlobalElementsPermission
      ? () => ModalActions.show(UIRegions.InsertGlobalElementsModal)
      : () => ModalActions.show(UIRegions.GlobalElementsActivationModal);

    return (
      <div className="cs-toolbar-global-elements">
        <a onClick={globalElementAction} className="fa fa-2x fa-globe" />
      </div>
    );
  },

  _getKeyboardShortcuts() {
    return (
      <div className="cs-toolbar-keyboard-shortcuts">
        <a
          onClick={() => ModalActions.show(UIRegions.KeyboardShortcuts)}
          className="fa fa-2x fa-question-circle"
        />
      </div>
    );
  },

  // eslint-disable-next-line no-unused-vars
  _handleExpandCueClockClick(e) {
    CuesheetCueClockActions.toggleFullScreenClock();
  },

  _handleToggleSearchVisibility(e) {
    e.preventDefault();
    SearchActions.toggleVisibility();
  },

  _getShowMenuNode() {
    const { folderListStore, show } = this.state;
    const showId = show.get('_id');
    const showsList = folderListStore.get('list');
    if (!showsList) return null;

    const shows = OrderedMap(
      showsList
        .get('items')
        .map((item) => [
          item.getIn(['reference', 'object', '_id']),
          item.getIn(['reference', 'object']),
        ]),
    );

    /**
     * TODO: come back to this later...not showing the show menu if the show isn't in the show list...
     * this can happen if the show is a deleted or template show
     */
    if (!shows || !shows.size || !shows.has(showId)) return null;

    return (
      <ShowsMenu
        onChange={this._handleShowSelection}
        activeId={showId}
        shows={shows}
      />
    );
  },

  _handleShowSelection(show) {
    const { team, event } = this.state;

    return RouteActions.goToShowDisplayType(
      {
        teamId: team.get('_id'),
        eventId: event.get('_id'),
        showId: show.get('_id'),
      },
      show.get('displayType'),
    );
  },

  componentDidMount() {
    //TODO: reconsider this...don't like that we have to use a 'nextTick' operation here...but router context mutations don't force a rerender
    this.listenTo(RouteActions.goToShow, () =>
      setTimeout(() => this.forceUpdate(), 1),
    );

    const { params } = this.context.router.state;
    const { eventId, teamId } = params;

    EventFolderListActions.getAllDisplayTypes(teamId, eventId);
  },

  _shouldHaveOverUnder() {
    const displayActualDuration = this.state.show.get('displayActualDuration');
    const hasOverUnderPermission = this.state.permissions.get('overUnder');
    return hasOverUnderPermission && displayActualDuration;
  },
});
